import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, TextField } from "@mui/material";
import { Button, Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (title: string) => void;
};

const AddCategoryModal: React.FC<Props> = ({ open, onClose, onSubmit }) => {
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (!open) {
      setTitle("");
    }
  }, [open]);

  const handleSubmit = () => {
    const trimmedTitle = title.trim();
    if (!trimmedTitle) return;
    onSubmit(trimmedTitle);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "6px",
          boxShadow: "0px 12px 32px rgba(15, 23, 42, 0.18)",
          maxWidth: 640,
        },
      }}
    >
      <div className="benefits-ptv-modal">
        <header className="benefits-ptv-modal-header">
          <div>
            <p className="benefits-ptv-modal-eyebrow">Partner Program Configuration</p>
            <h3>Add New Category</h3>
            <p className="benefits-ptv-modal-subtitle">
              Configure a new category with partner tier
            </p>
          </div>
          <button
            type="button"
            className="benefits-ptv-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <Iconography icon="xmark" size={IconographySizes.Medium} />
          </button>
        </header>
        <DialogContent className="benefits-ptv-modal-content">
          <label className="benefits-ptv-modal-label" htmlFor="benefits-category-title">
            Category Name
          </label>
          <TextField
            id="benefits-category-title"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            fullWidth
            placeholder="e.g., Technical Excellence"
            size="small"
          />
        </DialogContent>
        <footer className="benefits-ptv-modal-footer">
          <Button variant="secondary" label="CANCEL" onClick={onClose} />
          <Button
            variant="primary"
            label="ADD CATEGORY"
            onClick={handleSubmit}
            disabled={!title.trim()}
          />
        </footer>
      </div>
    </Dialog>
  );
};

export default AddCategoryModal;
